import React, { useState, useEffect } from 'react';
import axios from 'axios';

interface CategoryTabsProps {
  selectedCategory: string;
  onSelectCategory: (category: string) => void;
}

interface Category {
  _id: string;
  name: string;
  icon: string;
  image: string;
  enabled: boolean;
}

const API_BASE_URL = 'https://api.bringit.co.in/api';

const CategoryTabs: React.FC<CategoryTabsProps> = ({ selectedCategory, onSelectCategory }) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/categories/enabled`);
      setCategories([
        { _id: 'all', name: 'All', icon: '🏪', image: '', enabled: true },
        ...response.data
      ]);
    } catch (error) {
      console.error('Error fetching categories:', error);
      // Fallback to default categories if API fails
      setCategories([
        { _id: 'all', name: 'All', icon: '🏪', image: '', enabled: true },
        { _id: 'grocery', name: 'Grocery', icon: '🛒', image: '', enabled: true },
        { _id: 'pharmacy', name: 'Pharmacy', icon: '💊', image: '', enabled: true },
        { _id: 'vegetables', name: 'Vegetables', icon: '🥬', image: '', enabled: true },
        { _id: 'meat', name: 'Meat', icon: '🥩', image: '', enabled: true },
        { _id: 'bakery', name: 'Bakery', icon: '🍞', image: '', enabled: true },
      ]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '15px', textAlign: 'center' }}>Loading categories...</div>;
  }
  return (
    <div style={{
      display: 'flex',
      overflowX: 'auto',
      gap: '12px',
      padding: '15px 15px',
      backgroundColor: 'white',
      borderBottom: '1px solid #f0f0f0',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    }}>
      {categories.map((category) => (
        <button
          key={category._id}
          onClick={() => onSelectCategory(category._id)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '5px',
            padding: '10px 16px',
            border: 'none',
            borderRadius: '12px',
            background: selectedCategory === category._id 
              ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              : '#f8f9fa',
            color: selectedCategory === category._id ? 'white' : '#333',
            fontSize: '13px',
            fontWeight: selectedCategory === category._id ? '600' : '500',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            minWidth: '80px',
            whiteSpace: 'nowrap',
            boxShadow: selectedCategory === category._id 
              ? '0 4px 12px rgba(102, 126, 234, 0.3)'
              : 'none',
          }}
        >
          {category.image ? (
            <img 
              src={category.image} 
              alt={category.name}
              style={{
                width: '32px',
                height: '32px',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
          ) : (
            <span style={{ fontSize: '24px' }}>{category.icon}</span>
          )}
          <span>{category.name}</span>
        </button>
      ))}
    </div>
  );
};

export default CategoryTabs;
